import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import ErrorBoundary from './ErrorBoundary.jsx';
import { installGlobalErrorHandlers } from './lib/report-error.js';
import { APP_VERSION } from './version.js';
import './styles.css';
import './nonbilling-release.css';

// Catches what the React boundary can't: event handlers, timers, and
// rejected promises nobody awaited.
installGlobalErrorHandlers(APP_VERSION);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {/* Outermost so a crash anywhere — including inside the router or
        the auth gate — still lands on a real screen with a way out,
        rather than unmounting the tree to a blank page. */}
    <ErrorBoundary appVersion={APP_VERSION} context="app-root">
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);
